import React, { Component } from 'react';
import store from '../../store';
import { HandleSubmit } from '../../func/HandleSubmit';
import '../../component/AutoComplete.css'
import matchSorter from 'match-sorter'
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import ProgressDetailView from "../Progress/ProgressDetailView";
import ProgressDetailEdit from "../Progress/ProgressDetailEdit";
import ProgressDetailConfirm from "../Progress/ProgressDetailConfirm";

let reftable = React.createRef;
let ref1;
class RequestStatusList extends Component {

    reqest_number = "";
    constructor(props) {
        super(props);
        this.state = {
            TableOfRequest: [],
            Loading: true,
            PageChangetable: 0,
            PageSizetable: 20,
            Filtertable: [],
            Sorttable: [],
        };
        this.DeleteRequest = this.DeleteRequest.bind(this);
        this.YesFunc = this.YesFunc.bind(this);
        this.NoFunc = this.NoFunc.bind(this);
        //     this.ReloadAgain = this.props.reloadagain.bind(this);
    }
    NoFunc(index) {
        this.setState({
            show_rem_row: this.state.show_rem_row
        });
    }
    async YesFunc(ReqNum) {
        this.DeleteRequest(ReqNum);
        //  this.ReloadAgain();
        this.setState({
            Loading: true
        });
        await this.GetTableOfRequest();
        this.setState({
            Loading: false
        });
    }
    async DeleteRequest(req_code) {
        const sendparameter = {
            object: "request",
            detail: { request_code: req_code }
        }
        var response_info = await HandleSubmit('delete/index', sendparameter);
    }
    async GetTableOfRequest() {
        var response_info = await HandleSubmit('getdata/gettableofrequest', { progress: this.props.progress });
        this.setState({
            TableOfRequest: (response_info),
        });
    }
    async componentDidMount() {
        store.dispatch({ type: 'pishfactors' });
        this.setState({
            Loading: true
        });
        await this.GetTableOfRequest();
        this.setState({
            Loading: false
        });
    }

    componentWillReceiveProps() {
        this.setState({
            SubPage: this.props.subpage
        });

    }
    render() {
        //if (this.state.Loading === true) return(<div>Loading....</div>)
        if (this.state.Loading) { return <div>در حال بارگزاری.....</div> }
        let ActionExpander = '';
        return (
            <div>
                <ReactTable
                    className="-striped -highlight"
                    filterable

                    //onPageSizeChange={(e) =>  this.setState({ PageSizetable: e })}
                    onPageSizeChange={(e) => this.setState({ PageSizetable: e })}
                    onPageChange={(e) => this.setState({ PageChangetable: e })}
                    onSortedChange={(e) => this.setState({ Sorttable: e })}
                    onFilteredChange={(e) => this.setState({ Filtertable: e })}

                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                    data={this.state.TableOfRequest}
                    //filterable

                    SubComponent={(row) => {
                        switch (ActionExpander) {
                            case "confirm":
                                return (<ProgressDetailConfirm action={ActionExpander} request_code={row.original.request_code}
                                    progress={this.props.progress} />
                                );
                            case "view":
                                console.log("row", row);
                                return (<ProgressDetailView action={ActionExpander} request_code={row.original.request_code}
                                    progress={this.props.progress} />
                                );
                            case "edit":
                                return (<ProgressDetailEdit action={ActionExpander} request_code={row.original.request_code}
                                    progress={this.props.progress} />
                                );
                            case "remove":
                                return (
                                    <RemRow ReqNum={row.original.request_code} no={() => this.NoFunc(row.original.request_code)} yes={() => this.YesFunc(row.original.request_code)} />
                                );
                        }

                    }
                    }
                    columns={[
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{!isExpanded ? <span><button className="btn btn-outline-warning" onClick={() => ActionExpander = "view"}>+</button></span> : <span><button className="btn btn-outline-warning">-</button></span>}</div>
                                )
                            },
                        },
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> شماره سفارش</div>,
                            accessor: "request_code"
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> صاحب سفارش  </div>,
                            accessor: "request_owner"
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>اقدام کننده </div>,
                            accessor: "user_name",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>تاریخ </div>,
                            accessor: "date"
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>توضیحات </div>,
                            accessor: "desc"
                        },
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{!isExpanded ? <span><button className="btn btn-outline-success" onClick={() => ActionExpander = "confirm"}>تایید</button></span> : <span><button className="btn btn-outline-success">-</button></span>}</div>
                                );
                            },
                        },
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{!isExpanded ? <span><button className="btn btn-outline-warning" onClick={() => ActionExpander = "edit"}>ویرایش</button></span> : <span><button className="btn btn-outline-warning">-</button></span>}</div>
                                );
                            },
                        },
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{!isExpanded ? <span><button className="btn btn-outline-danger" onClick={() => ActionExpander = "remove"}>حذف</button></span> : <span><button className="btn btn-outline-danger">-</button></span>}</div>
                                );
                            },
                        },
                    ]}
                    defaultPageSize={20}
                    className="-striped -highlight"

                />

            </div>
        );
    }
}
export default (RequestStatusList);
class RemRow extends Component {
    styles = {
        table: {
            textAlign: 'right',
            borderTop: "0px solid black",
            padding: "3px 20px"
        }
    }
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.Loading) { return "در حال بارگزاری..."; }
        return (
            <React.Fragment>
                <tr><td style={this.styles.table} colSpan="7" >آیا مایل به حذف درخواست {this.props.ReqNum} هستید؟</td></tr>
                <tr><td style={this.styles.table} colSpan="7"><button className="btn btn-danger" style={{ 'marginLeft': '10px' }} onClick={this.props.yes}>بله</button><button className="btn btn-danger" onClick={this.props.no}>خیر</button></td></tr>
            </React.Fragment>
        )
    }
}





// WEBPACK FOOTER //
// ./src/pages/Request/RequestStatusList.js